import React from "react"
import classes from "./Tabs.module.css"
import Tab from "../../components/Tabs/Tab/Tab"
import { useTranslation } from "react-i18next"
import { hasContext, valid_key } from "../../Utils"

const Tabs = props => {
    const { t } = useTranslation()

    const get_tabs = () => {
        const r = [t("misc:Profile.Settings"), t("misc:Profile.BadgeProgress"), t("misc:Profile.UpdateProgress")]
        if (valid_key() || hasContext()) {
            r.push(t("misc:Profile.Seeds"))
        }
        return r
    }

    return (
        <ul className={classes.Nav}>
            {get_tabs().map((v, idx) => {
                return <Tab title={v} key={idx} clicked={props.clicked} active={props.active === idx} num={idx} />
            })}
        </ul>
    )
}

export default Tabs
